module.exports = __webpack_public_path__ + "./images/9535fd7f6f2b21385ab8098914b993a0.webp";